import {Component, EventEmitter, Input, Output} from '@angular/core';
import {AppLinkBuilder} from '../../../utils';
import {IconType, PtEntity} from '@pt/pt-models';

@Component({
  selector: 'pt-details-card',
  templateUrl: './details-card.component.html',
  styleUrls: ['./details-card.component.scss']
})
export class DetailsCardComponent {
  @Input() title?: string;
  @Input() entity: PtEntity;
  @Input() entityId: number;
  @Input() text: string;
  @Input() noDataMessage!: string;
  @Input() showNoData = false;
  @Input() showWarning = false;
  @Input() warningMessage?: string;
  @Input() showInfo = false;
  @Input() infoMessage?: string;
  @Output() clickOpen = new EventEmitter();

  SVG = IconType.SVG;

  openDetails() {
    window.open(AppLinkBuilder.linkOfEntity(this.entity, this.entityId), '_blank');
  }
}
